import type { StrategiesSettingsModel } from '@/shared/generated'

import { useTranslation } from 'react-i18next'

import { StrategyView } from '@/widgets/scenario-strategy'

import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from '@/shared/components/ui/card'

export function ScenarioStrategySettingsCard({
	settings,
}: {
	settings?: StrategiesSettingsModel
}) {
	const { t } = useTranslation()

	if (!settings) return null

	return (
		<Card>
			<CardHeader className='gap-0'>
				<CardTitle>
					{t('pricing_strategy', { defaultValue: 'Pricing strategy' })}
				</CardTitle>
			</CardHeader>
			<CardContent>
				<StrategyView data={settings} />
			</CardContent>
		</Card>
	)
}
